var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"nav"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"analytic__toggler"},[_vm._v("\n      Analytics View\n      "),_c('Toogle',{attrs:{"value":_vm.toggleStatus},on:{"toggle":function (value) { return _vm.handleToggle(value); }}})],1)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c555e76","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/RNPLNavbar.vue
// module id = null
// module chunks = 